import { MessageSquare } from 'lucide-react'
import { CALLOUT_BG, CALLOUT_TEXT } from './noteStyle'

/** Keep the guide's plate off the pane's right edge. */
const PROMPT_CLAMP = 260

export interface WorkbenchPinPromptProps {
  x: number
  y: number
  paneW: number
  /** What a click (or a drop) here would pin to: "Trend line", "Sep 3, 2026 10:00 UTC candle", "this spot". */
  target: string
}

/**
 * The guide under the pointer while a callout is being pinned — the Callout armed, or a
 * callout's tail being dragged: what it would pin to right here. It wears the callout's yellow,
 * so the plate reads as the note-to-be.
 */
export function WorkbenchPinPrompt({ x, y, paneW, target }: WorkbenchPinPromptProps) {
  return (
    <div className="pointer-events-none absolute inset-0 z-[105]" data-pin-prompt="callout">
      <div
        className="absolute flex items-center gap-1.5 whitespace-nowrap rounded-md px-2 py-1 text-caption shadow-popover"
        style={{
          left: Math.min(x + 14, Math.max(0, paneW - PROMPT_CLAMP)),
          top: y + 14,
          // The callout's own colours (it has no token: it is a user-pickable fill).
          background: CALLOUT_BG,
          color: CALLOUT_TEXT,
        }}
      >
        <MessageSquare size={12} strokeWidth={2} aria-hidden className="shrink-0" />
        <span>Pin a callout</span>
        <span className="opacity-70">→ {target}</span>
      </div>
    </div>
  )
}
